import firebase from 'firebase/app'
import api from '../plugins/api'
async function socialLoginRegister(providerName, locale) {
  try {
    let provider = null
    switch (providerName) {
      case 'facebook':
        provider = new firebase.auth.FacebookAuthProvider()
        break
      case 'apple':
        provider = new firebase.auth.OAuthProvider('apple.com')
        break
    }
    provider.addScope('email')
    firebase.auth().languageCode = locale
    provider.setCustomParameters({
      display: 'popup',
      locale: locale
    })
    const firebaseUserRes = await firebase.auth().signInWithPopup(provider)
    const firebaseToken = await firebaseUserRes.user.getIdToken()
    const tokenResponse = await api.post(
      '/user/token',
      { token: firebaseToken },
      { headers: { Authorization: firebaseToken } }
    )
    const tokenServer = tokenResponse.data.token
    return tokenServer
  } catch (errorFirebase) {
    console.log(errorFirebase)
    throw errorFirebase
  }
}

export { socialLoginRegister }
